/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2020-05-24 13:59:41
 * @LastEditors: sueRimn
 * @LastEditTime: 2020-05-24 14:33:28
 */

import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'
import videos from './modules/videos'
import uploads from './modules/uploads'
import broadcasts from './modules/broadcasts'
import { getColumnistInfo, getColumnistInfoNum } from '@/services/user'
import { getBanner } from '@/services/banner'
import { isIphone, isAphone, isIpad, isInApp, parseQuery } from '@/utils/mUtil'
import { userInfoMock, deviceInfoMock } from '@/constants/mock'

import RootState from './types'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

function getUserInfo() {
  return new Promise((resolve, reject) => {
    if (location.href.indexOf('debugger') > -1) {
      const params = parseQuery(location.href)
      return resolve(Object.assign({}, userInfoMock, params))
    }
    if (isInApp()) {
      MgtvApi.getUserInfo((data: any) => {
        resolve(data && JSON.parse(data).ticket ? JSON.parse(data) : {})
      })
    } else if (debug) {
      resolve(userInfoMock)
    } else {
      reject('MgtvApi.getUserInfo error')
    }
  })
}

function getDeviceInfo() {
  return new Promise((resolve, reject) => {
    if (isInApp()) {
      MgtvApi.getDeviceInfo((data: any) => {
        resolve(JSON.parse(data))
      })
    } else if (debug) {
      resolve(deviceInfoMock)
    } else {
      reject('MgtvApi.getDeviceInfo error')
    }
  })
}

function getCommonParam(userInfo: any, deviceInfo: any) {
  const platform = isIphone()
    ? 'iphone'
    : isIpad()
    ? 'ipad'
    : isAphone()
    ? 'android'
    : ''
  return {
    uuid: userInfo.uuid,
    ticket: userInfo.ticket,
    token: userInfo.ticket,
    device: deviceInfo.device,
    did: deviceInfo.did,
    deviceId: deviceInfo.did,
    appVersion: deviceInfo.appVersion,
    osType: deviceInfo.osType,
    platform,
    abroad: 0,
    entrance: 6,
  }
}

const store: StoreOptions<RootState> = {
  state: {
    userInfoInapp: {},
    // @ts-ignore
    userInfo: JSON.parse(sessionStorage.getItem('userInfo')) || {},
    homeData: {},
    userInfoNum: {},
  },
  getters: {
    isLogin(state) {
      const userInfoInapp = state.userInfoInapp
      return state.userInfoInapp && Object.keys(userInfoInapp).length > 0
    },
    hasFetchUserInfo(state) {
      // 是否请求过用户数据了
      const userInfoNum = state.userInfoNum
      return state.userInfoNum && Object.keys(userInfoNum).length > 0
    },
  },
  mutations: {
    UpdateUserInfo(state, userInfo) {
      sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
      state.userInfo = userInfo
    },

    UpdateUserInfoNum(state, userInfoNum) {
      state.userInfoNum = userInfoNum
    },

    UpdateUserInfoInapp(state, userInfoInapp) {
      state.userInfoInapp = userInfoInapp
    },

    UpdateHomeData(state, homeData) {
      state.homeData = homeData
    },

    UpdateUserApplyStatus(state, applyStatus) {
      if (state.userInfo && state.userInfo.extInfo) {
        state.userInfo.extInfo.settledStatus = applyStatus
      }
    },
  },
  actions: {
    // 自动获取用户信息
    async autoLogin({ commit }: any) {
      try {
        const userinfo: any = await getUserInfo()
        console.log('自动获取用户信息', userinfo)
        if (!userinfo) {
          return
        } else {
          commit('UpdateUserInfo', '')
        }
        commit('UpdateUserInfoInapp', userinfo)
        if (userinfo.uuid) {
          const { uuid, ticket } = userinfo
          this.dispatch('getColumnistInfoAction', { uuid, ticket })
          this.dispatch('getColumnistInfoNumAction', { uuid, ticket })
        }
      } catch (error) {
        console.log(error)
      }
    },

    async getColumnistInfoAction({ commit }, { uuid, ticket }) {
      try {
        const res = await getColumnistInfo(uuid, ticket)
        console.log('用户信息', res.data)
        res.data && commit('UpdateUserInfo', res.data)
      } catch (error) {
        console.log(error)
      }
    },

    async getColumnistInfoNumAction({ commit }, { uuid, ticket }) {
      try {
        const res = await getColumnistInfoNum(uuid, ticket)
        res.data && commit('UpdateUserInfoNum', res.data)
      } catch (error) {
        console.log(error)
      }
    },

    // 获取闪图数据
    async getBannerAction({ state, commit }: any) {
      try {
        const deviceInfo = await getDeviceInfo()
        console.log('deviceInfo', deviceInfo)
        const params = getCommonParam(state.userInfoInapp, deviceInfo)
        const { data } = await getBanner(params)
        if (data.code == 200) {
          commit('UpdateHomeData', data.data)
        }
      } catch (error) {
        console.log(error)
      }
    },

    async login() {
      console.log('login')
      MgtvApi.login(() => {
        // console.log('location.href', location.href)
        // this.dispatch('autoLogin')
        location.reload()
      })
    },
  },
  modules: {
    videos,
    uploads,
    broadcasts,
  },
  strict: debug,
}

export default new Vuex.Store<RootState>(store)

// export default new Vuex.Store({
//   state: {
//     userInfoInapp: {}, // app的用户信息
//     userInfo: { uuid: 'xxx' }, // 接口请求的用户信息
//     up: {},
//     videos: {
//       list: [],
//       current: 'id',
//     },
//     broadcasts: {
//       list: [],
//     },
//   },
//   getters: {
//     isLogin(state) {
//       const userInfoInapp = state.userInfoInapp
//       return state.userInfoInapp && Object.keys(userInfoInapp).length
//     },
//   },
//   mutations: {},
//   actions: {},
//   modules: {},
// })
